import { render } from "./textarea_input.vue?vue&type=template&id=35d765cf&lang=pug"
import script from "./textarea_input.vue?vue&type=script&lang=js"
export * from "./textarea_input.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__